import { Component, inject, input, numberAttribute, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PlayerSessionService } from '../../services/player-session.service';
import { Dossier } from '../../shared/dossier/dossier';
import { StatePanel } from '../../shared/state-panel/state-panel';

// Reprise d'une mission avec un acces regenere par l'organisateur (TD-017, TD-023) :
// /missions/:missionId/access#<jeton>. Le fragment n'est jamais envoye au serveur ;
// la navigation remplace aussitot l'entree d'historique qui le contient.
@Component({
  selector: 'app-access-page',
  imports: [Dossier, StatePanel],
  templateUrl: './access-page.html',
})
export class AccessPage implements OnInit {
  readonly missionId = input.required({ transform: numberAttribute });

  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly session = inject(PlayerSessionService);

  ngOnInit(): void {
    const token = this.route.snapshot.fragment;
    if (!token) {
      this.router.navigate(['/not-authorized'], { replaceUrl: true });
      return;
    }
    this.session.save({
      missionId: this.missionId(),
      agentToken: decodeURIComponent(token),
      codeName: null,
    });
    this.router.navigate(['/missions', this.missionId()], { replaceUrl: true });
  }
}
